import { render, staticRenderFns } from "./notification_success.vue?vue&type=template&id=0866913c&"
import script from "./notification_success.vue?vue&type=script&lang=ts&"
export * from "./notification_success.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports